import React, { useState } from 'react';
import { X, Copy, CheckIcon, BookmarkIcon, Clock } from 'lucide-react';
interface CouponModalProps {
  coupon: any;
  onClose: () => void;
  onSave: () => void;
  isSaved: boolean;
}
export function CouponModal({
  coupon,
  onClose,
  onSave,
  isSaved
}: CouponModalProps) {
  const [copied, setCopied] = useState(false);
  const copyCode = () => {
    if (coupon.code) {
      navigator.clipboard.writeText(coupon.code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-142">
      <div className="bg-white rounded-xl max-w-md w-full animate-fade-in" data-id="element-143">
        <div className="p-4 flex justify-between items-center border-b border-gray-200" data-id="element-144">
          <h3 className="font-bold text-lg" data-id="element-145">Coupon Details</h3>
          <button className="p-1 rounded-full hover:bg-gray-100" onClick={onClose} data-id="element-146">
            <X size={20} className="text-black" data-id="element-147" />
          </button>
        </div>
        <div className="p-6" data-id="element-148">
          <div className="flex justify-between items-start mb-4" data-id="element-149">
            <h2 className="text-xl font-bold" data-id="element-150">
              {coupon.brand || coupon.title}
            </h2>
            {coupon.brand && <img src={`https://logo.clearbit.com/${coupon.brand.toLowerCase()}.com?size=40`} alt={coupon.brand} className="h-8" onError={e => {
            ;
            (e.target as HTMLImageElement).style.display = 'none';
          }} data-id="element-151" />}
          </div>
          {coupon.description && <p className="text-gray-600 mb-4" data-id="element-152">{coupon.description}</p>}
          {coupon.highlight && <div className="bg-gray-100 p-4 rounded-lg mb-4 text-center" data-id="element-153">
              <span className="text-4xl font-bold flex justify-center items-center" data-id="element-154">
                {coupon.highlight} {coupon.icon}
              </span>
              {coupon.subtext && <p className="text-sm text-gray-600 mt-1" data-id="element-155">{coupon.subtext}</p>}
            </div>}
          {coupon.code && <div className="mb-4" data-id="element-156">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-157">
                Coupon Code
              </label>
              <div className="flex" data-id="element-158">
                <div className="flex-grow bg-gray-100 border border-gray-300 rounded-l-lg p-3 font-mono text-lg text-center" data-id="element-159">
                  {coupon.code}
                </div>
                <button className={`px-4 rounded-r-lg flex items-center justify-center transition ${copied ? 'bg-green-500 text-white' : 'bg-gray-200 hover:bg-gray-300'}`} onClick={copyCode} data-id="element-160">
                  {copied ? <CheckIcon size={20} className="text-white" data-id="element-161" /> : <Copy size={20} className="text-black" data-id="element-162" />}
                </button>
              </div>
            </div>}
          {coupon.expiryDate && <div className="flex items-center text-sm text-gray-600 mb-4" data-id="element-163">
              <Clock size={16} className="mr-1 text-black" data-id="element-164" />
              <span data-id="element-165">Expires on {coupon.expiryDate}</span>
            </div>}
          <div className="flex items-center gap-3 mt-6" data-id="element-166">
            <button className="flex-grow bg-green-500 hover:bg-green-600 text-white py-3 rounded-lg font-medium transition" onClick={onClose} data-id="element-167">
              {coupon.buttonText || 'Claim Coupon'}
            </button>
            <button className={`p-3 rounded-lg ${isSaved ? 'bg-yellow-100 text-yellow-600' : 'bg-gray-100 hover:bg-gray-200'} transition`} onClick={onSave} data-id="element-168">
              <BookmarkIcon size={20} className={isSaved ? 'fill-yellow-400 text-black' : 'text-black'} data-id="element-169" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}